var map = {
  "./mobile/photolist": [
    "42115",
    "96216",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "6532",
    "99268",
    "76904",
    "44588"
  ],
  "./desktop/photolist": [
    "9901",
    "9598",
    "76225",
    "62815",
    "89513",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "99268",
    "26012",
    "20470",
    "80582"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 76573;
module.exports = __rspack_async_context;
